import * as api from "app/api/templates"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import { handleError } from "app/redux/errorHandler/errorHandler.saga"
import * as actions from "./templateWeekAvailabilities.actions"

export function* getWeekAvailabilities(action: actions.GetWeekAvailabilitiesAction): SagaIterator {
  try {
    const response = yield call(api.getWeekAvailabilities, action.payload)
    yield put(actions.getWeekAvailabilitiesSuccess(response && response.data))
  } catch (e) {
    yield put(actions.getWeekAvailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* templateWeekAvailabilitiesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getWeekAvailabilities)
}
